import { License, Package, TierPricing } from '@app/store/shared/models';

export function resolvePricingTiers(license: License, pkg: Package): TierPricing[] {
    const custom = pkg.customPricingList.find(
        (entry) => entry.relatedEntityType === license.relatedEntityType && entry.relatedEntityId === license.relatedEntityId,
    );

    return custom?.pricingList ?? pkg.pricingList;
}
